import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RichTooltipDirective } from '../../directives/Tooltip.directive';
import { TranslatePipe } from '../../directives/TranslatePipe';
import { IEntityMetaData } from '../../../_models/IEntityMetaData';


@Component({
  selector: 'app-modified-field-badge',
  standalone: true,
  imports: [CommonModule, RichTooltipDirective, TranslatePipe],
  templateUrl: './modified-field-badge.component.html'
})
export class ModifiedFieldBadgeComponent {
  @Input() index!: number;
  @Input() totalModified: number = 0;
  @Input() property!: string;
  @Input() entity: any; // L'entité avec les métadonnées
  @Input() toggleUndoFn!: (property: string) => void;

  @ViewChild('tooltipHost', { read: RichTooltipDirective }) tooltipDirective?: RichTooltipDirective;


  @Output() undoRedoPerformed = new EventEmitter<string>();

  get isUndoActive(): boolean {
    return this.entity?._undoState?.get(this.property) ?? false;
  }

  get metaData(): IEntityMetaData {
    return this.entity.GetType(); 
  }

  getContext() {
    const change = this.entity._changeMap?.get(this.property);
    return {
      entity: this.entity,
      property: this.property,
      oldValue: change?.old,
      newValue: change?.new,
      isUndoActive: this.isUndoActive,
      toggleUndo: () => {
        this.toggleUndoFn(this.property);
        this.undoRedoPerformed.emit(this.property);
        setTimeout(() => this.tooltipDirective?.hide(true), 0); // fermeture immédiate
      },
      dismiss: () => { }
    };
  }
}

